import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../components/dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../components/authorization/authorization.service';
import { WindowRef } from '../utils/window';

import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../shared/models/banner';
import { TranslateUtil } from '../utils/translate-util';
import { APP_CONSTANTS } from '../utils/app-constants';
import { AccoutDetailsResponse } from '../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { ContractNumberRequest } from '../shared/models/contractNumberResponse';
import { DcsAccountNumber } from '../shared/models/dcsAccountNumber';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SharedTranslateModule } from '../utils/sharedTranslateModule';
import { AdminPortalComponent } from '../components/adminportal/adminportal.component';
import { MatButtonModule } from '@angular/material/button';
enum CheckeBill {
  Enroll_ebill,
  Terminate_ebill,
  NONE
};



export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-adminprofilepage',
    templateUrl: './adminprofile.component.html',
    imports: [SharedTranslateModule, MatTableModule, MatButtonToggleModule, ReactiveFormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, AdminPortalComponent, MatSortModule],
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})


export class AdminProfileComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  password2 = '';
  hideMultipleSelectionIndicator=true;
  password3 = '';
  reTypePassword = '';
  brandId: string;
  action = '';
  error = '';
  loginAttempt = false;
  isLoginattempt = '';
  enrollFlagFromDB: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  baseUrl = '';
  currentPassword = '';
  emailAddress = '';
  streetAddress ='';
  city ='';
  state ='';
  zipCode='';
  currentPasswordDBCheckFlag = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  isAdmin: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  managePassword = false;
  passwordReset = false;
  hasUpperCase = false;
  hasLowerCase = false;
  hasNumeric = false;
  hasMinimum = false;
  hasMaximum = false;
  userIDcheck = false;
  reentercheck = false;
  confirmReset = false;
  confirmEnroll = false;
  confirmTerminate = false;
  confirmEbillReset = false;
  reentermailcheck = false;
  confirmMailReset = false;
  contractSelected = false;
  password = '';
  hide = false;
  hide1 = false;
  hide2 = false;
  passwordRequest: any = {};
  EmailRequest: any = {};
  EbillRequest: any = {};
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  language = '';
  emailOffers = true;
  isReset = false;
  userExist = false;
  marked = false;
  // theCheckbox = true;
  ciamId = sessionStorage.getItem('loginID');
  manageProfileForm: FormGroup;
  manageEmailForm: FormGroup;
  changeAddressForm :FormGroup;
  SelectEmail = true;
  SelectChangePassword = false;
  SelectAdmin = false;
  disabledFlag =false;
  dataLoaded=true;
  CANCEL = '';
  // check_box_eBill = CheckeBill;
  // currentlyChecked: CheckeBill;
  // checkeBill = CheckeBill;
  // selectedEbill = CheckeBill.NONE;

  //used for mat-toggle
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option6;
  value = '';

  contract: ContractNumberRequest;
  dscAccount: DcsAccountNumber;
  dscAccountList: DcsAccountNumber[];

  accountDetailsRes: AccoutDetailsResponse[];
  tableLoaded = true;

  filterActive = false;
  filter = false;
  rowCount = 0;

  stateLabelValues = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Guam', value: 'GU' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
  ];

  stateCanadaLabelValues = [
    {
        "label": "Alberta",
        "value": "AB"
    },
    {
        "label": "British Columbia",
        "value": "BC"
    },
    {
        "label": "Manitoba",
        "value": "MB"
    },
    {
        "label": "New Brunswick",
        "value": "NB"
    },
    {
        "label": "Newfoundland and Labrador",
        "value": "NL"
    },
    {
        "label": "Northwest Territories",
        "value": "NT"
    },
    {
        "label": "Nova Scotia",
        "value": "NS"
    },
    {
        "label": "Nunavut",
        "value": "NU"
    },
    {
        "label": "Ontario",
        "value": "ON"
    },
    {
        "label": "Prince Edward Island",
        "value": "PE"
    },
    {
        "label": "Quebec",
        "value": "QC"
    },
    {
        "label": "Saskatchewan",
        "value": "SK"
    },
    {
        "label": "Yukon Territory",
        "value": "YT"
    }
];

      // Table columns
  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'contractNum',
      display: 'Contract',
      displayFR: 'Numéro de contrat',
      dispFormat: 'contract'
    },
    {
      name: 'lastPayRcvd',
      display: 'Last Payment',
      displayFR: 'Dernier paiement reçu',
      dispFormat: 'currency'
    },
    {
      name: 'contractType',
      display: 'Contract Type',
      displayFR: 'Type de contrat',
      dispFormat: ''
    },
    {
      name: 'termDate',
      display: 'Maturity Date',
      displayFR: 'Date de maturité',
      dispFormat: 'date'
    },
    {
      name: 'totalDue',
      display: 'Current Due',
      displayFR: 'Solde actuel',
      dispFormat: 'currency'
    },
    {
      name: 'currentDt',
      display: 'Due Date',
      displayFR: 'Date d\'échéance',
      dispFormat: 'date'
    },
   {
      name: 'status',
      display: 'Status',
      displayFR: 'Statu',
      dispFormat: ''
    }
  ];
    displayedColumns: any[] = this.initColumns.map(col => col.name);
  
  
  dataSource: MatTableDataSource<AccoutDetailsResponse>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<AccoutDetailsResponse>(true, []);


  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    this.accountDetailsRes =[];
    this.dataSource = new MatTableDataSource(this.accountDetailsRes);
  }

  ngAfterViewInit() {
  }


  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    this.disabledFlag = false;
    this.SelectChangePassword = false;
    this.SelectAdmin=false;
   if (this.selectedState === 1) {
      this.SelectChangePassword = true;
    }
    else if (this.selectedState === 2) {
      this.SelectAdmin = true;
    }  
  }

  onURLChangeButton(num: number) { //Used for mat-toggle conditions to filter DB
    this.selectedState = num;
    this.disabledFlag = false;
    this.SelectChangePassword = false;
    this.SelectAdmin=false;
   if (this.selectedState === 1) {
      this.SelectChangePassword = true; 
    }
    else if (this.selectedState === 2) {
      this.SelectAdmin = true;
    }  
  }

  ngOnInit() {
    this.isAdmin = sessionStorage.getItem('isAdmin');
    sessionStorage.removeItem('addressdialog');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    
    let element: HTMLElement = document.getElementById('auto_triggeraddress') as HTMLElement;
    element.click();
    const openProfile = (this._window.nativeWindow as any).mbfs.openProfile;
    if(openProfile ==="yes"){
      this.onURLChangeButton(2);
    }else{
      this.onURLChangeButton(1);
    }
   // this.getAlerts();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

  formValidationClasses = {
    'mbfs-error': true,
  };
  buildForm() {
    this.manageProfileForm = this.fb.group({
      currentPassword: [''],
      password: [''],
      reTypePassword: ['']
    });
  }
  //Password Validation
  onClickPassword(e: Event): void {
    this.buildForm();
    this.openLoginModal = true;
    //build login form
    this.manageProfileForm.get('currentPassword').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      this.currentPasswordValidationCheck(),
      Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
    );
    this.manageProfileForm.get('password').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      this.passwordValidationCheck(),
      Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
    );
    this.manageProfileForm.get('reTypePassword').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      this.passwordEqualsCheck(),
      Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')]),
    );

  }

  passwordValidationCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let passwordvalue = this.manageProfileForm.get('password').value;

      let notUserId = false;
      if (passwordvalue != this.userId) {
        notUserId = true;
      }
      this.userIDcheck = notUserId;
      this.hasUpperCase = /[A-Z]+/.test(passwordvalue);
      this.hasLowerCase = /[a-z]+/.test(passwordvalue);
      this.hasNumeric = /[0-9]+/.test(passwordvalue);
      this.hasMinimum = passwordvalue.length >= 12;
      this.hasMaximum = passwordvalue.length <= 30;
      const passwordValid = this.hasUpperCase && this.hasLowerCase && this.hasNumeric && this.userIDcheck;

      return !passwordValid ? { passwordStrength: true } : null;
    }
  }

  currentPasswordValidationCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let passwordvalue = this.manageProfileForm.get('currentPassword').value;

      let notUserId = false;
      if (passwordvalue != this.userId) {
        notUserId = true;
      }
      this.userIDcheck = notUserId;
      this.hasUpperCase = /[A-Z]+/.test(passwordvalue);
      this.hasLowerCase = /[a-z]+/.test(passwordvalue);
      this.hasNumeric = /[0-9]+/.test(passwordvalue);
      this.hasMinimum = passwordvalue.length >= 12;
      this.hasMaximum = passwordvalue.length <= 30;

      const passwordValid = this.hasUpperCase && this.hasLowerCase && this.hasNumeric && this.userIDcheck;

      return !passwordValid ? { passwordStrength: true } : null;
    }
  }

  passwordEqualsCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let resetvalue = this.manageProfileForm.get('reTypePassword').value;
      let passwordvalue = this.manageProfileForm.get('password').value;
      let notpasswordEqual = false;
      if (resetvalue === passwordvalue) {
        notpasswordEqual = true;
      }
      this.reentercheck = notpasswordEqual;
      const passwordValid = this.reentercheck;
      return !passwordValid ? { passwordStrength: true } : null;
    }
  }

  updateAndSaveNewPassword(e: Event) {
    this.dataLoaded=false;
    this.passwordRequest = {};
    if (!this.manageProfileForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
        this.serviceErrorDesc = data;
      });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 7000);  //2s
      this.dataLoaded=true;
      return;
    }
    this.disabledFlag = true;
    let AdminName = sessionStorage.getItem('AdminName');
    this.password = this.manageProfileForm.get('password').value;
    this.reTypePassword = this.manageProfileForm.get('reTypePassword').value;
    this.currentPassword = this.manageProfileForm.get('currentPassword').value;
    this.passwordRequest = {
      ciamId: AdminName,
      currentPassword: this.currentPassword,
      password: this.password,
      reTypePassword: this.reTypePassword
    };
    this.auth.updateAndSaveNewAdminPassword(this.passwordRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.currentPasswordDBCheckFlag = true;
        this.confirmReset = true;
        this.translate.get('LoginModal.SuccessPassword').subscribe((data: any) => {
          this.serviceErrorDesc = data;
        });
      }
      else {
        this.disabledFlag = false;
        this.translate.get('LoginModal.InvalidCurrentPassword').subscribe((data: any) => {
          this.serviceErrorDesc = data;
        });
        this.serviceErrorOccurred = true;
        this.currentPasswordDBCheckFlag = false;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 7000);  //2s
      }
      this.dataLoaded=true;
    });
  }

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
  }

  changeType(input_field_password, bool) {
    if (input_field_password.type === 'password') {
      input_field_password.type = 'text';
    } else {
      input_field_password.type = 'password';
    }
    bool = !bool;
  }

  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  openDialog(num:any): void {
    if(num===1){
      sessionStorage.setItem('addressdialog', 'one');
    }
    if(num===5){
      sessionStorage.setItem('addressdialog', 'error');
    }
  let dialogRef = this.dialog.open(AdminProfileDialogComponent, {
    maxWidth: '200vw',
    width: '500px',
  });
}
}



@Component({
    selector: 'dialog-adminprofilePopup',
    imports: [
        MatButtonModule,
        MatDialogContent, MatDialogActions,
        MatDialogClose,
    ],
    templateUrl: 'adminprofileDialog.component.html'
})
export class AdminProfileDialogComponent {
  usUrl: string;
  caUrl: string;
  addressdialog: string;
  language : string;
  errorMessage: string;
  contractNumberList: ContractNumberRequest[];

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog

  ) {
    this.contractNumberList = [];
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.addressdialog = sessionStorage.getItem('addressdialog');
    this.language = sessionStorage.getItem('language');

    this.auth.cast2.subscribe((results:any)=> {
      this.contractNumberList = results;
     });
     this.auth.cast3.subscribe((errorMessage:any)=> {
      this.errorMessage = errorMessage;
     });
  }

dashboardRedirect(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }
}